<template>
    <div id="sig-container" class="full form-horizontal">
        <div class="loader" v-if="loading"><i class="fa fa-spinner fa-2x fa-spin text-info"></i></div>
        <div class="form-group text-right">
            <button @click="$router.go(-1)" class="btn btn-sm btn-primary">Volver</button>
        </div>
        <table-component :data="abonos" v-if="abonos.length > 0" :footerTable="[{type:'suma', column:'valor'}]">
            <table-column slot="label" :label="'ID'" v-bind:value="'id'"></table-column>
            <table-column slot="label" :label="'Fecha'" v-bind:value="'fecha'"></table-column>
            <table-column slot="label" :label="'Valor'" v-bind:value="'valor'" :filter="'numberFormat'" :customClass="'text-right'"></table-column>
        </table-component>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    name: 'Abonos',
    data: () => {
        return {
        }
    },
    components: {
        TableComponent: () => import('@@/components/table/TableComponent'),
        TableColumn: () => import('@@/components/table/TableColumn')
    },
    computed: {
        ...mapGetters({'loading': 'loading', 'abonos': 'abonos/abonos'})
    },
    methods: {
        getAbonos(obligacion_id) {
            this.$store.dispatch('abonos/refresh_abonos', []);
            this.$store.dispatch('index', {endpoint: 'abono', params: {codigo: obligacion_id}})
            .then((response) => {
                if (response.datos.length > 0){
                    this.$store.dispatch('abonos/refresh_abonos', response.datos)
                } else {
                    this.$notify({
                        title: 'Advertencia!',
                        type: 'warning',
                        content: 'No se encontraron abonos con el código dado',
                    })
                }
            })
            .catch(() => {
                this.$notify({
                    title: 'Advertencia!',
                    type: 'danger',
                    content: 'Se ha presentado un error realizando su consulta',
                })
            })
        }
    },
    mounted() {
        this.getAbonos(this.$route.params.obligacion_id);
    }
}
</script>
